import BaseStore from './base-store.js'
import StoreProxy from './store_proxy.js'
import {API2_SHTOPICS} from 'consts/api2'


export class ShTopic extends BaseStore {
  constructor(values = {}) {
    super({
      id: crypto.randomUUID(),
      name: undefined,
      followers_cnt: undefined,
      created_at: undefined,
      ...values
    })
  }

  async doSave(rest, changed) {
    const to_write = {}
    for (const key of changed) to_write[key] = this._state[key]
    const {bleach} = await rest.patch(`${API2_SHTOPICS}/${this.id}`, to_write)
    this._bleach(bleach)
  }
}


export class ShTopics extends BaseStore {
  constructor() {
    super({
      view_items: [],
      view_total: 0,
      total: 0,
    })
  }

  getTopic(id) {
    return this._state.view_items.find(x => x.id === id)
  }

  async newTopic(data) {
    const topic = await this._rest.post(API2_SHTOPICS, data)
    return new ShTopic(topic)
  }

  async doLoad(rest, params) {
    const result = await (rest || this._rest).get(API2_SHTOPICS, params)
    this._state.view_items = result.view_items.map(data => new ShTopic(data))
    this._state.view_total = result.view_total
    this._state.total = result.total
  }
}


const topics = StoreProxy(new ShTopics(), {array_prop: 'view_items'})
export default topics
